import React, { useState } from "react";
import "./RequestQuote.css";
import {
  FaCity,
  FaMapMarkerAlt,
  FaBuilding,
  FaClipboardList,
  FaCommentDots,
  FaCubes,
  FaTruck,
  FaShieldAlt,
  FaHandshake,
  FaEnvelope,
  FaPhoneAlt,
  FaCheckCircle,
  FaArrowLeft,
  FaTimes,
} from "react-icons/fa";
import { db, ref, set } from "../Firebase/firebase-config";
import { push } from "firebase/database";
import { Helmet } from "react-helmet-async";
import ReCAPTCHA from "react-google-recaptcha";

const cementBrands = [
  { name: "UltraTech", img: "/Images/Ultra-Banner.png" },
  { name: "Shree", img: "/Images/Shree-Banner.png" },
  { name: "JK Super", img: "/Images/JK-Banner.png" },
  { name: "Ambuja", img: "/Images/Ambuja-Banner.png" },
  { name: "ACC", img: "/Images/Acc-Banner.png" },
  { name: "JSW", img: "/Images/Jsw-Banner.png" },
];

const cementGrades = ["OPC 43", "OPC 53", "PPC", "PSC"];

export default function RequestQuote() {
  const [formData, setFormData] = useState({
    city: "",
    area: "",
    brand: [],
    grade: [],
    email: "",
    phone: "",
    quantity: "",
    unit: "Bags",
    requirement: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactError, setContactError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBrandSelect = (brandName) => {
    setFormData((prev) => {
      const alreadySelected = prev.brand.includes(brandName);
      return {
        ...prev,
        brand: alreadySelected
          ? prev.brand.filter((b) => b !== brandName)
          : [...prev.brand, brandName],
      };
    });
  };

  const handleGradeSelect = (grade) => {
    setFormData((prev) => {
      const alreadySelected = prev.grade.includes(grade);
      return {
        ...prev,
        grade: alreadySelected
          ? prev.grade.filter((g) => g !== grade)
          : [...prev.grade, grade],
      };
    });
  };

  const handleUnitSelect = (unit) => {
    setFormData((prev) => ({ ...prev, unit }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !formData.city ||
      !formData.area ||
      formData.brand.length === 0 ||
      formData.grade.length === 0 ||
      !formData.quantity
    ) {
      alert(
        "Please fill all required fields (including at least one Brand and one Grade)."
      );
      return;
    }
    if (!captchaValue) {
      alert("Please verify that you're not a robot.");
      return;
    }
    setShowContactModal(true);
  };

  const handleFinalSubmit = async () => {
    const hasEmail = formData.email.trim() !== "";
    const hasPhone = formData.phone.trim() !== "";

    if (!hasEmail && !hasPhone) {
      setContactError("Please enter at least Email or Mobile Number.");
      return;
    }

    if (hasEmail) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        setContactError("Please enter a valid email address.");
        return;
      }
    }

    if (hasPhone) {
      if (!/^[6-9]\d{9}$/.test(formData.phone)) {
        setContactError("Please enter a valid 10-digit mobile number.");
        return;
      }
    }

    setContactError("");

    try {
      const newQuoteRef = push(ref(db, "quoteRequest"));
      await set(newQuoteRef, {
        ...formData,
        createdAt: Date.now(),
        status: "pending",
      });

      const notificationRef = push(
        ref(db, "supplier_notifications/Quotations")
      );
      await set(notificationRef, {
        category: "Quotations",
        gifUrl: "/Images/New notification.gif",
        message: `New quotation request received for ${formData.quantity} ${formData.unit} of ${formData.brand.join(", ")} (${formData.grade.join(", ")}). Delivery location: ${formData.area}, ${formData.city}. Contact: ${formData.phone || "N/A"}${formData.email ? ` | ${formData.email}` : ""}.`,
        seen: false,
        timestamp: new Date().toISOString(),
        title: "New Quote Request",
      });

      setSubmitted(true);
      setShowContactModal(false);
      setFormData({
        city: "",
        area: "",
        brand: [],
        grade: [],
        email: "",
        phone: "",
        quantity: "",
        unit: "Bags",
        requirement: "",
      });
      setCaptchaValue(null);
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    }
  };

  if (submitted) {
    return (
      <section className="quote-success-wrapper">
           <Helmet>
        <title>Cement Quote Request | Altrange</title>

        <meta
          name="description"
          content="Request a cement quote from Altrange. Get cement for construction projects, bulk orders, builders and contractors."
        />
      </Helmet>
        <div className="quote-success-card">
          <div className="success-icon">
            <FaCheckCircle />
          </div>
          <h2>Quote Request Submitted!</h2>
          <p>
            Thank you for your request.
            <br />
            Our team will contact you shortly with the best quotation.
          </p>
          <div className="success-buttons">
            <button
              className="back-btn"
              onClick={() => window.history.back()}
            >
              <FaArrowLeft />
              <span>Go Back</span>
            </button>
            <button
              className="new-request-btn"
              onClick={() => setSubmitted(false)}
            >
              New Request
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="quote-section">
      <div className="quote-card">
        <button
          type="button"
          className="quote-back-btn"
          onClick={() => window.history.back()}
        >
          <FaArrowLeft size={14} />
          <span>Back</span>
        </button>

        <div className="quote-header">
          <span className="quote-badge">GET BEST PRICE</span>
          <h2>Request Cement Rate
          
          </h2>
          <p>
            Compare prices from trusted cement suppliers and receive your
            quotation quickly.
          </p>
        </div>

        <div className="quote-note">
          <strong>* Note:</strong> We deal only in{" "}
          <strong>non-trade bulk cement orders</strong>.
        </div>

        <form onSubmit={handleSubmit} className="quote-form">
          {/* LOCATION SECTION */}
          <div className="form-section">
            <div className="section-title">Location</div>
            <div className="quote-grid">
              <div className="quote-input">
                <label>
                  <FaCity />
                  City <b className="text-danger">*</b>
                </label>
                <input
                  type="text"
                  name="city"
                  placeholder="e.g. Pune"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="quote-input">
                <label>
                  <FaMapMarkerAlt />
                  Area <b className="text-danger">*</b>
                </label>
                <input
                  type="text"
                  name="area"
                  placeholder="e.g. Wakad / Sector 62"
                  value={formData.area}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          {/* BRAND SECTION */}
          <div className="form-section">
            <div className="section-title">
              <FaBuilding /> Select Brand{" "}
              <b className="text-danger">*</b>
              <span className="multi-hint">(select multiple)</span>
            </div>
            <div className="brand-image-grid">
              {cementBrands.map((brand) => (
                <div
                  key={brand.name}
                  className={`brand-card ${
                    formData.brand.includes(brand.name) ? "selected" : ""
                  }`}
                  onClick={() => handleBrandSelect(brand.name)}
                >
                  <img
                    src={brand.img}
                    alt={brand.name}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                  <div className="brand-fallback">{brand.name}</div>
                  <span className="brand-name">{brand.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* GRADE SECTION */}
          <div className="form-section">
            <div className="section-title">
              <FaClipboardList /> Select Grade{" "}
              <b className="text-danger">*</b>
              <span className="multi-hint">(select multiple)</span>
            </div>
            <div className="grade-btn-group">
              {cementGrades.map((grade) => (
                <button
                  type="button"
                  key={grade}
                  className={`grade-btn ${
                    formData.grade.includes(grade) ? "selected" : ""
                  }`}
                  onClick={() => handleGradeSelect(grade)}
                >
                  {grade}
                </button>
              ))}
            </div>
          </div>

          {/* QUANTITY SECTION */}
          <div className="form-section">
            <div className="section-title">Quantity</div>
            <div className="quantity-row">
              <div className="quote-input unit-input">
                <label>
                  <FaCubes /> Unit <b className="text-danger">*</b>
                </label>
                <div className="unit-toggle">
                  <button
                    type="button"
                    className={`unit-btn ${
                      formData.unit === "Bags" ? "active" : ""
                    }`}
                    onClick={() => handleUnitSelect("Bags")}
                  >
                    Bags
                  </button>
                  <button
                    type="button"
                    className={`unit-btn ${
                      formData.unit === "MT" ? "active" : ""
                    }`}
                    onClick={() => handleUnitSelect("MT")}
                  >
                    MT
                  </button>
                </div>
              </div>
              <div className="quote-input qty-input">
                <label>
                  <FaCubes /> Quantity <b className="text-danger">*</b>
                </label>
                <input
                  type="number"
                  name="quantity"
                  placeholder="Enter Quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  required
                  min={1}
                  onWheel={(e) =>e.target.blur()}
                />
              </div>
            </div>
          </div>

          {/* PROJECT DETAILS */}
          <div className="form-section">
            <div className="quote-input">
              <label>
                <FaCommentDots />
                Project Details{" "}
                <span className="optional-text">(Optional)</span>
              </label>
              <textarea
                rows={3}
                name="requirement"
                maxLength={200}
                placeholder="Example: Road Works. Delivery required within 2 days. Preferred delivery time: Morning."
                value={formData.requirement}
                onChange={handleChange}
              />
              <small className="text-counter">
                {formData.requirement.length}/200 characters
              </small>
            </div>
          </div>

          {/* CAPTCHA */}
          <div className="captcha-box">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(value) => setCaptchaValue(value)}
            />
          </div>

          <button type="submit" className="quote-submit-btn">
            Request Quote
          </button>
        </form>
      </div>

      {/* TRUST BOX */}
      <div className="quote-trust">
        <div className="trust-item">
          <FaTruck />
          <h4>Fast Delivery</h4>
          <p>Delivery across India</p>
        </div>
        <div className="trust-item">
          <FaShieldAlt />
          <h4>Trusted Suppliers</h4>
          <p>Verified Cement Dealers</p>
        </div>
        <div className="trust-item">
          <FaHandshake />
          <h4>Best Prices</h4>
          <p>Competitive market quotations</p>
        </div>
      </div>

      {/* CONTACT MODAL */}
      {showContactModal && (
        <div className="contact-modal-overlay">
          <div className="contact-modal">
            <button
              className="modal-close-btn"
              onClick={() => {
                setShowContactModal(false);
                setContactError("");
              }}
            >
              <FaTimes />
            </button>
            <h3 className="contact-title">
              How would you like to receive your quotation?
            </h3>
            <p className="contact-desc">
              Enter your <span>Email</span>, <span>Mobile Number</span>, or{" "}
              <span>both</span> to receive the <strong>best quotation</strong>.
            </p>

            <div className="quote-input">
              <label>
                <FaEnvelope /> Email Address
              </label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email (optional if phone given)"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="quote-input">
              <label>
                <FaPhoneAlt /> Mobile Number
              </label>
              <input
                type="tel"
                name="phone"
                placeholder="Enter mobile number (optional if email given)"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
              />
            </div>

            {contactError && <p className="contact-error">{contactError}</p>}

            <p className="privacy-text">
              By continuing you agree to our{" "}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </p>

            <button
              className="quote-submit-btn modal-submit"
              onClick={handleFinalSubmit}
            >
              Get Quote
            </button>
          </div>
        </div>
      )}
    </section>
  );
}